import { render, staticRenderFns } from "./ManageHomePage.vue?vue&type=template&id=28f5dab2&"
import script from "./ManageHomePage.vue?vue&type=script&lang=js&"
export * from "./ManageHomePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports